import React, { useState } from "react";

export default function Accordion({ title, children, defaultOpen = false, style = {} }) {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div style={{ marginBottom: 12, borderRadius: 6, overflow: "hidden", width: "100%", ...style }}>
      {/* Header */}
      <div
        onClick={() => setIsOpen(!isOpen)}
        style={{
          background: "#ff5722",
          color: "#fff",
          padding: "12px 20px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          cursor: "pointer",
          fontWeight: 700,
          fontSize: 14,
          textTransform: "uppercase",
          letterSpacing: "0.5px",
        }}
      >
        <span>{title}</span>
        <span style={{ fontSize: 18 }}>{isOpen ? "⌄" : "›"}</span>
      </div>

      {/* Body */}
      {isOpen && (
        <div
          style={{
            background: "#fff",
            border: "1px solid #ff5722",
            borderTop: "none",
            padding: "24px 16px",
          }}
        >
          {children}
        </div>
      )}
    </div>
  );
}
